import { IEntity } from "@interfaces/entity";
import { Customer } from "./customer";
import { RfidCard } from "./rfidCard";

export class Tag implements IEntity{
  id: number;
  name: string;

  rfidCards: RfidCard[];

  customerId: number;
  customer: Customer;

  entityName = "Tag";

  constructor(formValue?: Partial<Tag>) {
    Object.assign(this, formValue);
  }

  updateValues(formValue: Partial<Tag>) {
    Object.assign(this, formValue);
  }

  getPrimaryKey() {
    return this.id;
  }
}
